$(() => {

  function responsiveImages() {
    const windowWidth = $(window).width();
    if (windowWidth > 991) {
      const imageContainers = $('[data-image-desktop]');
      _.forEach(imageContainers, (imageContainer) => {
        const desktopImage = $(imageContainer).data('image-desktop');
        $(imageContainer).css('background-image', `url(${desktopImage})`);
      });
    } else {
      const imageContainers = $('[data-image-mobile]');
      _.forEach(imageContainers, (imageContainer) => {
        const mobileImage = $(imageContainer).data('image-mobile');
        $(imageContainer).css('background-image', `url(${mobileImage})`);
      });
    }
  }

  responsiveImages();

  $(window).resize(() => {
    responsiveImages();
  });
});
